import type { ConstitutionalDocumentViewModel, ContractViewModel } from '@trinnvis/dabih-api-client';
import { translateTemplateName } from 'src/i18n/template-content';
import type { OrganizationState } from '../../types';
import { namesAsText } from './names-as-text';

export function toContractViewModel(
  item: ContractViewModel | ConstitutionalDocumentViewModel,
  o: OrganizationState,
):
  | (ContractViewModel & { contractPartyNames: string })
  | (ConstitutionalDocumentViewModel & { contractPartyNames: string }) {
  return Object.assign({}, item, {
    name: translateTemplateName(item.name),
    contractPartyNames: namesAsText(item, o, true),
  });
}
